import { motion, useReducedMotion } from 'framer-motion';
import { EASE, fadeUpItem, staggerParent } from '@/animations/variants';
import { Reveal } from '@/components/ui/Reveal';
import { facilities } from '@/mocks/salonData';
import { asset } from '@/utils/assets';

export default function FacilitiesSection() {
  const reduce = useReducedMotion();

  return (
    <section
      id="facilities"
      className="py-20 sm:py-28 lg:py-36 bg-soft-green"
    >
      <div className="max-w-6xl mx-auto px-6 sm:px-8">
        {/* Header */}
        <Reveal className="mb-12 sm:mb-16">
          <p className="section-label mb-4 text-earth">FACILITIES & SAFETY</p>
          <h2 className="font-serif-jp text-deep-brown text-xl sm:text-2xl lg:text-3xl leading-snug">
            設備と安全への取り組み
          </h2>
        </Reveal>

        {/* Content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-start">
          {/* Image */}
          <motion.div
            className="relative overflow-hidden rounded-lg"
            initial={reduce ? { opacity: 0 } : { opacity: 0, x: -12, y: 8 }}
            whileInView={{ opacity: 1, x: 0, y: 0 }}
            viewport={{ once: true, margin: '-10% 0px' }}
            transition={{ duration: 0.7, ease: EASE, delay: 0.12 }}
          >
            <div className="w-full h-64 sm:h-80 lg:h-[420px]">
              <img
                alt="サロン設備"
                className="w-full h-full object-cover object-top"
                src={asset('images/facilities.jpg')}
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-forest/20 to-transparent rounded-lg"></div>
          </motion.div>

          {/* Facility list */}
          <div>
            <Reveal className="space-y-8" variants={staggerParent}>
              {facilities.map((facility) => (
                <motion.div
                  key={facility.title}
                  className="flex items-start gap-5"
                  variants={fadeUpItem}
                >
                  <motion.div
                    className="flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-lg bg-forest/10 border border-forest/25 mt-0.5"
                    whileHover={reduce ? undefined : { scale: 1.05 }}
                    transition={{ duration: 0.25, ease: EASE }}
                  >
                    <i className={`${facility.icon} text-forest text-lg`}></i>
                  </motion.div>
                  <div>
                    <h4 className="font-serif-jp text-deep-brown font-medium mb-2 text-base">
                      {facility.title}
                    </h4>
                    <p className="font-sans-jp text-earth/85 text-sm leading-relaxed">
                      {facility.description}
                    </p>
                  </div>
                </motion.div>
              ))}
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}